import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_PREFEITURAS_API } from 'services/rotasp/path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestAlteraPrefeiturasServicosCanais } from './types';

// ACTIONS
import {
	alteraPrefeiturasServicosCanaisSuccess,
	alteraPrefeiturasServicosCanaisFailure,
} from './actions';
import { consultaPrefeiturasServicosCanaisRequest } from '../consultaPrefeiturasServicosCanais/actions';

function* alteraPrefeiturasServicosCanais(request: ReducerAction) {
	const {
		token = '',
		payload,
	}: { token?: string; payload: IRequestAlteraPrefeiturasServicosCanais } =
		request;

	const response: ApiResponse = yield call(
		putApi,
		token,
		PATH_PREFEITURAS_API,
		`prefeituras/servicos/${payload.idPrefeituraServico}/canais`,
		payload.body,
	);

	if (response.status === 200) {
		yield put(alteraPrefeiturasServicosCanaisSuccess(payload));
		yield put(consultaPrefeiturasServicosCanaisRequest(token, payload));
	} else if (response.error) {
		yield put(alteraPrefeiturasServicosCanaisFailure(response.message));
	}
}

export default all([
	takeLatest(
		Types.ALTERA_PREFEITURA_SERVICOS_CANAIS,
		alteraPrefeiturasServicosCanais,
	),
]);
